import { useEffect, useState } from 'react';
import { AppSection } from '../../components/forms';
import { AppPendingBet } from '../../components';
import { useAppStore } from '../../store/AppStore';
import { useWallet, useConnection } from '@solana/wallet-adapter-react';
import axios from 'axios';
import { CircularProgress, Grid, IconButton, Skeleton, Typography } from '@mui/material';
import { usePendingBetsContext } from '../../context/PendingBetsContext';
import CachedIcon from '@mui/icons-material/Cached';
/**
 * Renders demo section for Tags and TagCloud
 */
const PendingBetsSection = ({ useTagCloud = false }) => {
  const wallet = useWallet();
  const { connection } = useConnection();
  const [pending_bets, setPendingBets] = useState([]);
  const [state, dispatch] = useAppStore();
  const { data: pendingBetsData, isLoading, refreshData } = usePendingBetsContext();

  useEffect(async () => {

    setPendingBets(pendingBetsData);
  }, [pendingBetsData, state.transaction]);


  return (
    <AppSection
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Pending bets</Typography>
          <IconButton onClick={refreshData}>{isLoading ? <CircularProgress size={25} /> : <CachedIcon />}</IconButton>
        </div>
      }
      outline="outlined"
      sx={{ marginTop: 2, maxHeight: '500px', overflow: 'auto' }}
    >
      {isLoading ? (
        <Skeleton width="100%" height="15rem" />
      ) : (
        pending_bets.map((bet, index) => <AppPendingBet item={bet} key={index} />)
      )}
    </AppSection>
  );
};

export default PendingBetsSection;
